import { ElDialog } from "element-plus";

export function setupElementECDefaults() {
  ElDialog.props.width.default = "500px";
  ElDialog.props.alignCenter.default = true;
  ElDialog.props.showClose.default = false;
}
